module.exports = __webpack_public_path__ + "static/media/Icon-ReceiveMoney.d632ca6f.png";